"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSecondTwoDigit = exports.getSecondNumeric = void 0;
var pad_number_to_length_1 = require("../utils/pad-number-to-length");
/**
 * Returns a numerical representation of the second: 0, 1, ..., 59
 * @hidden
 */
var getSecondNumeric = function (_a) {
    var date = _a.date;
    // don't need to localise as seconds do not change between time zones.
    return date.getSeconds();
};
exports.getSecondNumeric = getSecondNumeric;
/**
 * Returns a two-digit string representation of the second: 00, 01, ..., 59
 * @hidden
 */
var getSecondTwoDigit = function (params) {
    var seconds = exports.getSecondNumeric(params);
    return pad_number_to_length_1.padNumberToLength(seconds, 2);
};
exports.getSecondTwoDigit = getSecondTwoDigit;
//# sourceMappingURL=second.js.map